import memoize from 'transmute/memoize';
import SearchContentTypes from '../data/constants/SearchContentTypes';
export const getFilteredTableColumns = memoize((tableColumns, looseItemContentType, folderContentType, isDocumentsMultiBrandEnabled) => {
  const shouldShowBrand = isDocumentsMultiBrandEnabled && (looseItemContentType === SearchContentTypes.DOCUMENT || folderContentType === SearchContentTypes.DOCUMENTS_FOLDER);
  return shouldShowBrand ? tableColumns : tableColumns.filter(col => col.id !== 'brand');
});